import type { LicenceResponse, SendBulkInvitationResponse, UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';
import { toLinkedInUrlBody } from '@/shared/linkedin/linkedin-url';

import type { AddUserDraft } from '../domain/add-user-draft.model';
import type { AddUserGateway } from './add-user.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Add-user endpoints and the draft → snake_case body mapping (kept 1:1 with
 * the original `AddUser` page's `GET /licences` + `POST /users`, including the
 * email trim + lowercase). The LinkedIn URL goes out normalised, `null` if none.
 */
export const httpAddUserGateway: AddUserGateway = {
  fetchLicences: () => api.get<LicenceResponse[]>('/licences'),
  createUser: (draft: AddUserDraft) =>
    api.post<UserResponse>('/users', {
      first_name: draft.firstName.trim(),
      last_name: draft.lastName.trim(),
      email: draft.email.trim().toLowerCase(),
      licence_id: draft.licenceId,
      linkedin_url: toLinkedInUrlBody(draft.linkedinUrl),
    }),
  // The index's bulk endpoint with a single id (the `InvitationDialog` call), not
  // `/invitations/send`, which creates an administrator.
  inviteUser: (userId: string) =>
    api.post<SendBulkInvitationResponse['data']>('/invitations/send-bulk', {
      user_ids: [userId],
    }),
};
